module.exports = __webpack_public_path__ + "assets/img/3-1-en.2d42627a.png";